import React from "react";
import { CloseIcon } from "../../../assets/icons";
import FileDisplay from "../../../utils/FileDisplay";
import NuDateFormat from "../../../utils/NuDate";
import { ViewLabelwithDataBg } from "../../../components/View/ViewLabelwithData";

function ViewImplementationChecklist({ visible, onClose, data }) {
  if (!visible) return null;

  return (
    <div
      id="modal"
      className="bg-black bg-opacity-30 fixed inset-0 backdrop-blur-sm 
  flex justify-center items-center z-10"
    >
      <div className="bg-white p-2 rounded w-10/12 max-h-[calc(100vh-80px)] overflow-hidden">
        <div className="flex items-start justify-between px-5 py-2  rounded-t">
          <h3 className="text-base 2xl:text-xl capitalize font-semibold">
           {"Implementation Checklist View"}
          </h3>
          <span
            className="h-6 w-6 text-2xl block cursor-pointer"
            onClick={onClose}
          >
            <CloseIcon />
          </span>
        </div>
        <div className="overflow-y-auto max-h-[calc(100vh-140px)]">
          <div>
            <ViewLabelwithDataBg title="Section No." value={data?.section_no || "-"} />
            <ViewLabelwithDataBg title="Section" value={data?.section || "-"} />
            <ViewLabelwithDataBg title="Sub Section No." value={data?.sub_section_no || "-"} />
            <ViewLabelwithDataBg title="Sub Section" value={data?.sub_section || "-"} />
            <ViewLabelwithDataBg title="Questions / Activity" value={data?.question_activity || "-"} />
            <ViewLabelwithDataBg title="User Response" value={data?.user_response || "-"} />
            <ViewLabelwithDataBg title="User Comment" value={data?.user_comment || "-"} />
            <ViewLabelwithDataBg title="Status" value={data?.status || "-"} />
            <ViewLabelwithDataBg title="Completion Date" 
              value={(data?.completion_date != "None" &&
                     data?.completion_date != " " &&
                     NuDateFormat({
                     value: data?.completion_date,
                     format: "DD-MMM-yyyy",
                  })) ||
                  "-"} />
            <ViewLabelwithDataBg title="Reminder Date" 
              value={(data?.reminder_date != "None" &&
                     data?.reminder_date != " " &&
                     NuDateFormat({
                     value: data?.reminder_date,
                     format: "DD-MMM-yyyy",
                  })) ||
                  "-"} />
            <div className="my-3 text-left">
              <p className="text-sm text-[#1D1818] font-semibold mb-1 pl-8">
              Attachment Artefact
              </p>
              <div className=" w-full flex flex-wrap">
                {data?.image_path &&
                  data?.image_path.map((i) => {
                    return (
                      <div className=" m-1">
                        <FileDisplay data={i} view={true} height={"45px"} width={"45px"} />
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewImplementationChecklist;
